<div class="panel-header" [class.panel-header--vertical]="vertical">
  <div class="panel-header-desc">
    <div class="panel-header-title">
      <div class="header-icon">
        <mat-icon svgIcon="{{ icon }}" *ngIf="isSvg; else notSvg"></mat-icon>
        <ng-template #notSvg>
          <mat-icon *ngIf="isOutline; else notOutline">
            <span class="material-symbols-outlined" [ngClass]="{ 'fill-icon': fill }"> {{ icon }}</span>
          </mat-icon>
          <ng-template #notOutline>
            <mat-icon>
              {{ icon }}
            </mat-icon>
          </ng-template>
        </ng-template>
      </div>
      <div class="header-title">
        {{ title | translate }}
      </div>
    </div>

    <div class="header-subtitle">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="panel-header-tool">
    <ng-content select="[tool]"></ng-content>
  </div>
</div>
